<template>
    <div>
        <Hero />
        <ServeYou />
        <ServeSections />
        <Vlogs />
        <Blogs />
        <Ebooks v-if="false" />
        <VlogPlayer />
    </div>
</template>
<script>
import Hero from "./hero.vue";
import ServeYou from "./serveYou.vue";
import ServeSections from "./serveSections/serveSections.vue";
import Blogs from "../blogs/featured.vue";
import Vlogs from "../vlogs/featured.vue";
// import Ebooks from "../ebooks/featured.vue";
import VlogPlayer from "../shared/vlogPlayer.vue";

export default {
    components: {
        Hero,
        ServeYou,
        ServeSections,
        Blogs,
        Vlogs,
        // Ebooks,
        VlogPlayer,
    },
};
</script>
